/* eslint-disable react/prop-types */
import { ArrowLeft, ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Top-left "← Back" for inner screens. Goes to the previous screen in the
 * app's history; when the page was opened directly (a shared link, a fresh
 * tab) there is nothing to go back to, so it navigates to `fallback` instead
 * of leaving the site or doing nothing. React Router keeps the history
 * position in history.state.idx (0 = first entry, even after a `replace`
 * redirect such as /customer/dashboard → /overview), which is more reliable
 * than location.key.
 * Same look as the document page's Back link.
 */
const BackLink = ({
  fallback = "/",
  className = "",
  showLabel = true,
  chevron = false,
  title,
}) => {
  const navigate = useNavigate();
  const Icon = chevron ? ChevronLeft : ArrowLeft;

  return (
    <button
      type="button"
      title={title}
      aria-label={showLabel ? undefined : title || "Back"}
      onClick={() => {
        const canGoBack = (window.history.state?.idx ?? 0) > 0;
        if (canGoBack) navigate(-1);
        else navigate(fallback);
      }}
      className={`inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition hover:gap-2.5 hover:underline ${className}`}
    >
      <Icon aria-hidden="true" className="h-4 w-4" strokeWidth={2.5} />
      {showLabel && "Back"}
    </button>
  );
};

export default BackLink;
